<template>
  <div>
    <div class="banner">
      <div class="title">
        <div class="flex">
          <div class="suc"><img src="../../assets/images/sucess.png" alt="" /></div>
          <div class="su1">恭喜你！支付成功</div>
        </div>
      </div>

      <div class="s2">感谢您的光顾，您可去<span style="color: #4076f6">我的订单</span>里查看订单详情</div>

      <div class="info">
        <div class="i1">
          <div class="num">支付金额：<span style="font-size: 15px">¥</span>{{ Number(orderInfo.payMoney).toFixed(2) }}</div>

          <div class="flex" style="justify-content: center; width: 100%">
            <div class="bor"></div>
          </div>

          <div class="flex f1" style="justify-content: space-between">
            <div class="i2">订单编号</div>
            <div class="i3">{{ orderInfo.orderNo }}</div>
          </div>
          <div class="flex f1" style="justify-content: space-between">
            <div class="i2">下单时间</div>
            <div class="i3">{{ orderInfo.createTime }}</div>
          </div>
          <div class="flex f1" style="justify-content: space-between">
            <div class="i2">支付时间</div>
            <div class="i3">{{ orderInfo.payTime }}</div>
          </div>
          <div class="flex f1" style="justify-content: space-between">
            <div class="i2">支付方式</div>
            <div class="i3">
              {{
                orderInfo.payType == '0902'
                  ? '微信支付'
                  : orderInfo.payType == '06'
                  ? '支付宝'
                  : orderInfo.payType == '07'
                  ? '支付宝'
                  : orderInfo.payType == '02'
                  ? '学习账户'
                  : '线上支付'
              }}
            </div>
          </div>

          <div class="btnBox">
            <div class="btn" @click="goHsa(1)">查看课程</div>
            <div class="btn b2" @click="goHsa(2)">查看订单</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { toPaySuccess } from '@/api/classDetail.js';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      orderInfo: {}
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    goHsa(type) {
      if (type == 1) {
        if (this.orderInfo.orderType == '06') {
          //职业培训订单
          this.$router.push({
            path: '/myClass',
            query: {
              name: 'b'
            }
          });
        } else if (this.orderInfo.orderType == '04') {
          //课程资源库单课购买
          this.$router.push('/membership');
        } else if (this.orderInfo.orderType == '05') {
          //会员课程资源库订单
          this.$router.push('/resource');
        } else {
          this.$router.push('/myClass');
        }
      } else {
        this.$router.push({
          path: '/myOrder',
          query: {
            type: 'success'
          }
        });
      }
    },
    //支付宝跳转过来后，调用接口获取数据
    toPaySuccess(id) {
      toPaySuccess({ orderNo: id }).then(res => {
        this.orderInfo = res.data.data;
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    //支付宝的回调
    if (this.$route.query.is_success) {
      if (this.$route.query.is_success == 'T') {
        this.toPaySuccess(this.$route.query.orderNo);
      }
    } else if (this.$route.query.dz == '1') {
      this.toPaySuccess(this.$route.query.orderNo);
    } else {
      this.orderInfo = this.$route.query;
      this.toPaySuccess(this.$route.query.orderNo);
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.flex {
  display: flex;
}
.banner {
  margin-top: 46px;
  padding-top: 32px;
  .title {
    width: 100%;
    display: flex;
    justify-content: center;
    .suc {
      width: 24px;
      height: 24px;
      background: #4076f6;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 2px;
      img {
        width: 16px;
        height: 16px;
      }
    }
    .su1 {
      margin-left: 8px;
      color: #333333;
      font-size: 20px;
      font-weight: 600;
    }
  }
  .s2 {
    margin-top: 6px;
    width: 100%;
    text-align: center;
    font-size: 12px;
    color: #333333;
  }
  .info {
    margin-top: 24px;
    padding: 0 15px;
    .i1 {
      width: 100%;
      background: #fff;
      height: 330px;
      border-radius: 10px 10px 10px 10px;
      padding: 20px 15px;
      .num {
        width: 100%;
        text-align: center;
        color: #000000;
        font-size: 22px;
        font-weight: 600;
      }
      .bor {
        margin-top: 26px;
        width: 200px;
        border: 1px dashed #bababa;
        margin-bottom: 4px;
      }
      .f1 {
        margin-top: 16px;
        .i2 {
          color: #667280;
          font-size: 14px;
        }
        .i3 {
          color: #333333;
          font-size: 14px;
        }
      }
      .btnBox {
        display: flex;
        justify-content: space-between;
        padding: 0 33px;
        margin-top: 30px;
        .btn {
          width: 110px;
          height: 36px;
          border-radius: 18px 18px 18px 18px;
          border: 1px solid #333333;
          text-align: center;
          line-height: 36px;
          color: #333333;
          font-size: 14px;
        }
        .b2 {
          color: #fff;
          border: 0 !important;
          background: #4076f6;
        }
      }
    }
  }
}
</style>
